import { Option, Schema as Schema_ } from '@blade/std-lib'
import { Network } from '@root/entities/network/model'

import * as TradeSettings from './trade-settings'

import type { TradeSettingsByNetworkListData } from '@blade/trade-api-client'

type PresetDto = TradeSettingsByNetworkListData['presets'][number]

export const Schema = Schema_.Struct({
  index: Schema_.Number,
  network: Network.Schema,
  name: Schema_.String,
  emoji: Schema_.String,
  settings: TradeSettings.SettingsSchema,
})

export interface Preset extends Schema_.Schema.Type<typeof Schema> {}

export const fromDto = (
  dto: PresetDto,
  index: number,
  network: Network.Network,
): Preset => {
  return {
    index,
    name: dto.name,
    emoji: dto.emoji,
    network,
    settings: TradeSettings.fromDto(dto, network),
  }
}

const FromJson = Schema_.fromJsonString(Schema)

export const byNetworkFromJson = (json: string) => {
  return Option.getOrUndefined(Schema_.decodeOption(FromJson)(json))
}

export const toJson = (settings: Preset) => {
  return Option.getOrUndefined(Schema_.encodeOption(FromJson)(settings))
}
